<div  class="flex w-full flex-col" *ngIf="informacionFichaRegistro$ | async">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 w-full justify-start items-stretch">
      <div class="border border-gray-300 h-full">
        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >ALTO</label>
          <input type="text" name="alto" [(ngModel)]="informacionTecnica.alto" id="alto" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >ANCHO</label>
          <input type="text" name="ancho" id="ancho" [(ngModel)]="informacionTecnica.ancho" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >LARGO</label>
          <input type="text" name="largo" id="largo" [(ngModel)]="informacionTecnica.largo" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >GROSOR</label>
          <input type="text" name="grosor" id="grosor" [(ngModel)]="informacionTecnica.Grosor" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >DIÁMETRO</label>
          <input type="text" name="diametro" id="diametro" [(ngModel)]="informacionTecnica.Diametro" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >ÁREA</label>
          <input type="text" name="area" id="area" [(ngModel)]="informacionTecnica.area" class="flex-1 pl-3 text-xs md:text-md">
          <span class="w-auto mx-2 text-xs md:text-md">m²</span>
        </div>

        <div class="flex flex-row items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >PROFUNDIDAD</label>
          <input type="text" name="profundidad" id="profundidad" [(ngModel)]="informacionTecnica.profundidad" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>
      </div>

      <div class="border border-gray-300 h-full md:grid md:items-stretch flex flex-col w-full">

        <div class="flex flex-row border-b border-gray-300 items-center justify-center h-auto w-full">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold">
            SERVICIO
          </label>
            <mat-select [(ngModel)]="serviciosSeleccionados" multiple class="w-8/12 md:w-9/12 px-3 text-xs md:text-md text-black"
              (ngModelChange)="onSelectionChange('servicio', $event)">
              <mat-select-trigger>
                <ng-container *ngIf="serviciosSeleccionados?.length" class="w-full truncate overflow-hidden">
                  <span *ngFor="let s of serviciosSeleccionados; let last = last">
                    {{ s.descripcion }}<span *ngIf="!last">, </span>
                  </span>
                </ng-container>
              </mat-select-trigger>
                      
              <mat-option *ngFor="let servicio of (servicios$ | async)" [value]="servicio">
                    {{ servicio.descripcion }}
                  </mat-option>
            </mat-select>

        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold">VALOR</label>
          <mat-select [(ngModel)]="valoresSeleccionados" multiple class="w-8/12 md:w-9/12 px-3 text-xs md:text-md text-black"
             (ngModelChange)="onSelectionChange('valor', $event)">
            <mat-select-trigger>
              <ng-container *ngIf="valoresSeleccionados.length">
                <span *ngFor="let v of valoresSeleccionados; let last = last" class="w-full truncate overflow-hidden">
                  {{ v.descripcion }}<span *ngIf="!last"> , </span>
                </span>
              </ng-container>
            </mat-select-trigger>
            <mat-option *ngFor="let valor of (valores$ | async)" [value]="valor">
              {{ valor.descripcion }}
            </mat-option>
          </mat-select>
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >MATERIAL</label>
          <input type="text" name="material" id="material" [(ngModel)]="informacionTecnica.material" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row border-b border-gray-300 items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >TÉCNICA</label>
          <input type="text" name="tecnica" id="tecnica" [(ngModel)]="informacionTecnica.tecnica" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>

        <div class="flex flex-row items-center justify-center">
          <label class="w-4/12 md:w-3/12 bg-gray-500 text-white h-full flex items-center pl-2 py-1 text-xs md:text-md font-semibold"
            >UTILERIA</label>
          <input type="text" name="utileria" id="utileria" [(ngModel)]="informacionTecnica.utileria" class="w-8/12 md:w-9/12 pl-3 text-xs md:text-md">
        </div>  
        
      </div>
    </div>

    <div class="mt-8 flex justify-start w-full ml-0 md:ml-0.5">
      <button mat-raised-button
        class="w-full md:w-40 rounded-md font-bold h-12" 
        (click)="actualizarInformacion()">Guardar</button>
    </div>
    
  </div>